export enum EFloorTypes {
  OnlyFirstFloor = 1,
  NotBasement = 2,
}
